<div class="text-center">Vehicle diagnostic data is not currently available for {{oemName}} vehicles. Please contact
  {{oemName}}
  to
  see
  if
  Vehicle Diagnostic data can be enabled within Power Lane.</div>